/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useAiPanel } from './AiPanelContext';

// Registers the current page's AI context for as long as the page is mounted.
//
// Usage from any container:
//
//   useAiPanelContext({
//     title: 'Note of Presentation 26007',
//     subtitle: 'License and Legal Affairs Department',
//     text: subjectAndBodyText,          // what the AI should read
//     suggestions: ['Summarize this note', 'Check for inconsistencies'],
//   }, [dependencies]);
//
// `deps` follows the same contract as useEffect: pass the values the context is
// derived from. It is required rather than optional because the common failure
// here is registering an object literal with no deps, which is a new reference
// on every render and would re-register in a loop.
function useAiPanelContext(context, deps) {
	const { registerPageContext, clearPageContext } = useAiPanel();

	useEffect(() => {
		registerPageContext(context);
		// Clearing on unmount is what makes the panel fall back to its empty
		// state when navigating to a page that has no AI context, instead of
		// showing the previous page's record.
		return () => clearPageContext();
	}, deps);
}

export default useAiPanelContext;
